module.exports = __webpack_public_path__ + "static/32-06578ed518ea7de52a4174452e7e3038.png";